import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollOrNavigate = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="nav-bar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F7EEDB]/85 backdrop-blur-2xl border-b border-[#D9C5A4]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 sm:py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand"
          aria-label="Mantel Summer Heels Experience"
          className="shrink-0"
        >
          {/* Logo nascosto visivamente, ma cliccabile per tornare alla home */}
          <span className="sr-only">Mantel · Summer Heels Experience</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <button
            data-testid="nav-link-experience"
            onClick={() => scrollOrNavigate("experience")}
            className="overline text-[#6E5B4A] hover:text-[#A0522D] transition"
          >
            L&apos;Esperienza
          </button>
          <button
            data-testid="nav-link-workshops"
            onClick={() => scrollOrNavigate("workshops")}
            className="overline text-[#6E5B4A] hover:text-[#A0522D] transition"
          >
            Workshop
          </button>
          <button
            data-testid="nav-link-reviews"
            onClick={() => scrollOrNavigate("recensioni")}
            className="overline text-[#6E5B4A] hover:text-[#A0522D] transition"
          >
            Recensioni
          </button>
          <button
            data-testid="nav-link-register"
            onClick={() => navigate("/register")}
            className="btn-primary"
          >
            Iscriviti
          </button>
        </div>

        <button
          data-testid="nav-toggle"
          className="md:hidden text-[#2A1810]"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F7EEDB] border-t border-[#D9C5A4] px-6 py-6 flex flex-col gap-5">
          <button
            data-testid="nav-mobile-experience"
            onClick={() => scrollOrNavigate("experience")}
            className="overline text-[#2A1810] text-left"
          >
            L&apos;Esperienza
          </button>
          <button
            data-testid="nav-mobile-workshops"
            onClick={() => scrollOrNavigate("workshops")}
            className="overline text-[#2A1810] text-left"
          >
            Workshop
          </button>
          <button
            data-testid="nav-mobile-reviews"
            onClick={() => scrollOrNavigate("recensioni")}
            className="overline text-[#2A1810] text-left"
          >
            Recensioni
          </button>
          <button
            data-testid="nav-mobile-register"
            onClick={() => {
              navigate("/register");
              setOpen(false);
            }}
            className="btn-primary justify-center"
          >
            Iscriviti
          </button>
        </div>
      )}
    </nav>
  );
};
